import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { useFormik } from 'formik';
import Address from '../../../../components/Address';
import Button from '@mui/material/Button';
import React, { useEffect, useState } from 'react';
import server from '../../../../services/server';
import { useConfirm } from 'material-ui-confirm';
import useErrors from '../../../../hooks/useErrors';
import {
    Alert,
    Box,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Checkbox,
    Chip,
    Divider,
    Grid,
    MenuItem,
    Paper,
    Switch,
    Typography,
} from '@mui/material';
import SelectPlan from '../../../../components/SelectPlan';
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel } from '@mui/material';
import useDialog from '../../../../hooks/useDialog';
import { useFetch } from '../../../../hooks/useFecth';
import { Link, useParams } from 'react-router-dom';
import SelectCategories from '../../../../components/SelectCategories';
import SelectCategoriesList from '../../../../components/SelectCategoriesList';
import SelectAdvertisers from '../../../../components/SelectAdvertisers';

import DnsIcon from '@mui/icons-material/Dns';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import * as Yup from 'yup';
import { Business, GetApp, MedicalServicesOutlined, ScienceOutlined } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

// function Edit({ id, mutate }) {
//     const { data } = useFetch(`club/${id}`);
//     return <Form data={data} mutate={mutate} />;
// }

// function Form({ data, mutate }) {
//     const { open, handleClose } = useDialog('#club');
//     const [errs, setErrs] = useState();
//     useErrors(errs);
//     const { enqueueSnackbar } = useSnackbar();

//     const { values, handleSubmit, handleChange, setFieldValue, setFieldError, setValues, isSubmitting } = useFormik({
//         initialValues: {
//             domain: '',
//             packageName: '',
//             appIntent: '',
//             primaryColor: '',
//             secundaryColor: '',
//             supportPhone: '',
//             supportEmail: '',
//         },
//         onSubmit: async (values, { setSubmitting }) => {
//             try {
//                 if (!Boolean(values.id)) {
//                     setSubmitting(true);
//                     await server.post(`club`, values);
//                     enqueueSnackbar(`Anunciante ${values.name} adicionado`);
//                 }

//                 if (Boolean(values.id)) {
//                     setSubmitting(true);
//                     await server.put(`club/${values.id}`, values);
//                     enqueueSnackbar(`Anunciante ${values.name} alterado`);
//                 }

//                 await mutate();
//                 setSubmitting(false);
//                 handleClose();
//             } catch (error) {
//                 setSubmitting(false);
//                 setErrs(error);
//             }
//         },
//     });

//     useEffect(() => {
//         if (data) {
//             console.log(data);
//             setValues({ ...data, address: `${data.street}, ${data.neighborhood}, ${data.city}-${data.state}` }, true);
//         }
//     }, [data]);

//     return (
//         <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
//             <DialogTitle>Adicionando/editando clube</DialogTitle>
//             <Divider />
//             <DialogContent>
//                 <Stack gap={2} sx={{ overflow: 'scroll' }}>
//                     {Boolean(values.id) && (
//                         <>
//                             <AddImage name="logo" onChange={setFieldValue} value={values.previewImage || values.logo} />
//                         </>
//                     )}

//                     <TextField label="Domínio personalizado" onChange={handleChange} name="domain" value={values.domain} />

//                     <TextField label="Package Name app" onChange={handleChange} name="packageName" value={values.packageName} />

//                     <Divider />

//                     <TextField label="Nome do clube" onChange={handleChange} placeholder="Nome do clube" name="name" value={values.name} />

//                     {Boolean(values.id) && (
//                         <TextField
//                             label="Razão Social"
//                             onChange={handleChange}
//                             placeholder="Razão social"
//                             name="businessName"
//                             value={values.businessName}
//                         />
//                     )}

//                     <TextField label="Documento" onChange={handleChange} placeholder="Documento" name="document" value={values.document} />

//                     <Address
//                         onChange={handleChange}
//                         setFieldValue={setFieldValue}
//                         name="zipcode"
//                         setFieldError={setFieldError}
//                         value={values.zipcode}
//                         address={values.address}
//                     />

//                     <TextField label="Complemento" onChange={handleChange} placeholder="Complemento" name="complement" value={values.complement} />

//                     <SelectPlan name="planId" value={values.planId} onChange={setFieldValue} />

//                     {Boolean(values.id) && (
//                         <>
//                             <FormControlLabel
//                                 control={<Switch checked={values.status} onChange={e => setFieldValue('status', e.target.checked)} />}
//                                 orientation="horizontal"
//                                 label="Status do clube"
//                             />
//                         </>
//                     )}
//                 </Stack>
//             </DialogContent>
//             <Divider />
//             <DialogActions>
//                 <Button variant="contained" type="submit" onClick={handleSubmit} loading={isSubmitting}>
//                     Salvar e continuar
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// }

function DialogSegments({ data, mutate }) {
    const { id: clubId } = useParams();
    const { open, handleClose } = useDialog('#segmentacao');

    const { setErrors, enqueueSnackbar } = useErrors();
 

    const { values, handleSubmit, handleChange, setFieldValue, setFieldError, setValues, isSubmitting } = useFormik({
        initialValues: {
            categoryIds: [],
            id: clubId,
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.put(`clubs/${clubId}/segment`, values);
                enqueueSnackbar(`Segmentação salva`);

                await mutate();
                setSubmitting(false);
                handleClose();
            } catch (error) {
                // console.log(error);
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            const { ClubCategory } = data;
            setValues({ categoryIds: ClubCategory.map(i => i.categoryId) }, true);
        }
    }, [data, open]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Adicionando/editando clube</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2}>
                    {/* <SelectCategories value={values.categoryIds} name="categoryIds" onChange={setFieldValue} label="Selecione as categorias" /> */}

                    <SelectCategoriesList onChange={setFieldValue} value={values.categoryIds} name="categoryIds" />
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button variant="contained" type="submit" onClick={handleSubmit} loading={isSubmitting}>
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogSegmentsExclude({ data, mutate }) {
    const { id: clubId } = useParams();
    const { open, handleClose } = useDialog('#excluidas');

    const { setErrors, enqueueSnackbar } = useErrors();

    const { values, handleSubmit, setFieldValue, setValues, isSubmitting } = useFormik({
        initialValues: {
            excludeCategory: [],
            excludeAdvertiser: [],
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.put(`clubs/${clubId}`, values);
                enqueueSnackbar(`Categorias excluídas alteradas`);

                await mutate();
                setSubmitting(false);
                handleClose();
            } catch (error) {
                // console.log(error);
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            const { excludeCategory, excludeAdvertiser } = data;
            setValues({ excludeCategory, excludeAdvertiser }, true);
        }
    }, [data, open]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Excluindo</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2}>
                    <SelectCategories
                        value={values.excludeCategory}
                        name="excludeCategory"
                        onChange={setFieldValue}
                        label="Selecione as categorias"
                    />
                    <SelectAdvertisers
                        value={values.excludeAdvertiser}
                        name="excludeAdvertiser"
                        onChange={setFieldValue}
                        label="Selecione os anunciantes"
                    />
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button variant="contained" type="submit" onClick={handleSubmit} loading={isSubmitting}>
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogApp({ data, mutate }) {
    const { id: clubId } = useParams();
    const { open, handleClose } = useDialog('#app');

    const { setErrors, enqueueSnackbar } = useErrors();

    const { values, handleSubmit, handleChange, setFieldValue, setFieldError, setValues, isSubmitting } = useFormik({
        initialValues: {
            appIntent: '',
            packageName: '',
            androidUrl: '',
            iosUrl: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.put(`clubs/${clubId}`, values);
                enqueueSnackbar(`Parametros alterados`);

                await mutate();
                setSubmitting(false);
                handleClose();
            } catch (error) {
                // console.log(error);
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            const { appIntent, packageName, androidUrl, iosUrl } = data;
            setValues({ appIntent, packageName, androidUrl, iosUrl }, true);
        }
    }, [data, open]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Parametros do aplicativo</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2}>
                    <TextField name="appIntent" label="App Intent" value={values.appIntent} onChange={handleChange} />
                    <TextField name="packageName" label="Package Name" value={values.packageName} onChange={handleChange} />
                    <TextField name="androidUrl" label="Android URL" value={values.androidUrl} onChange={handleChange} />
                    <TextField name="iosUrl" label="iOS URL" value={values.iosUrl} onChange={handleChange} />
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button variant="contained" type="submit" onClick={handleSubmit} loading={isSubmitting}>
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogCustomDomain({ data, mutate }) {
    const { open, handleClose } = useDialog('#custom-domain');
    const { enqueueSnackbar, setErrors } = useErrors();

    const { values, errors, getFieldProps, setFieldValue, handleSubmit, handleChange, setValues, isSubmitting, isValid } = useFormik({
        initialValues: {
            domain: '',
            action: 'update',
            status: '',
        },
        validationSchema: Yup.object({
            domain: Yup.string()
                .required('Campo obrigatório')
                .test('no-protocol-or-www', 'O domínio não deve começar com http, https ou www', value => {
                    if (!value) return true; // Allow empty value to be handled by .required()
                    return !value.startsWith('http://') && !value.startsWith('https://') && !value.startsWith('www.');
                }),
        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {
                setSubmitting(true);

                if (values.action === 'update') {
                    await confirm({ title: 'Adicionar domínio personalizado', description: `Você está adicionando o domínio ${values.domain}` });
                    await server.put(`clubs/${data.id}/domains`, { domain: values.domain });
                    enqueueSnackbar(`Domínio personalizado ${values.domain} adicionado com sucesso.`);
                }
                if (values.action === 'delete') {
                    await server.delete(`clubs/${data.id}/domains`);
                    enqueueSnackbar(`Domínio personalizado removido`);
                }
                await mutate();
                setSubmitting(false);
                resetForm();
                handleClose();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    const confirm = useConfirm();

    async function handleRemove() {
        await confirm({ title: 'Remover domínio', description: 'Você confirma a ação?' });
        setFieldValue('action', 'delete');
        handleSubmit();
    }

    useEffect(() => {
        if (data) {
            setValues({ domain: data.domain || '', action: 'update' });
        }
    }, [data]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Gerenciar Domínio Personalizado</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2}>
                    {data && data?.domainStatus?.length > 0 && (
                        <Alert severity="error">
                            Seu domínio tem erros e precisa ser ajustado: {data?.domainStatus.errors.map(({ message }) => message).join('. ')}
                        </Alert>
                    )}

                    <Typography variant="body1">
                        Para usar um domínio personalizado, você precisa configurá-lo no seu provedor de DNS. Siga as instruções abaixo:
                    </Typography>

                    <Stack direction="row" alignItems="center" gap={1}>
                        <DnsIcon color="primary" fontSize="large" />
                        <Typography variant="h6">Configuração de DNS</Typography>
                    </Stack>

                    <Typography variant="body2">1. Acesse o painel de controle do seu provedor de DNS (ex: GoDaddy, Cloudflare, etc.).</Typography>
                    <Typography variant="body2">2. Localize a seção de gerenciamento de DNS.</Typography>
                    <Typography variant="body2">
                        3. Adicione um registro do tipo <b>CNAME</b>.
                    </Typography>
                    <Typography variant="body2">
                        4. No campo <b>Nome/Host/Alias</b>, insira <b>www</b> (ou o subdomínio que deseja usar).
                    </Typography>
                    <Typography variant="body2">
                        5. No campo <b>Valor/Aponta para</b>, insira o valor fornecido abaixo:
                    </Typography>
                    <Alert severity="info">
                        <Typography variant="body2">
                            <b>{`eurobem-clube.pages.dev`}</b>
                        </Typography>
                    </Alert>
                    <Typography variant="body2">6. Salve as alterações.</Typography>
                    <Typography variant="body2">7. Aguarde a propagação do DNS (pode levar até 24 horas).</Typography>

                    <TextField
                        label="Seu Domínio Personalizado"
                        // name="domain"
                        // value={values.domain}
                        // onChange={handleChange}
                        {...getFieldProps('domain')}
                        disabled={Boolean(data.domain)}
                        error={Boolean(errors.domain)}
                        helperText={errors.domain}
                        placeholder="ex: meuclube.com.br"
                        fullWidth
                        inputProps={{
                            shrink: true,
                        }}
                    />
                    {values.domain && (
                        <Alert severity="warning">
                            <Typography variant="body2">
                                Ao remover o domínio personalizado, seu clube voltará a usar o domínio padrão do sistema.
                            </Typography>
                        </Alert>
                    )}
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                {data.domain && (
                    <Button variant="contained" type="submit" color="error" onClick={handleRemove} loading={isSubmitting} startIcon={<DeleteIcon />}>
                        Remover
                    </Button>
                )}
                {!data.domain && (
                    <Button
                        variant="contained"
                        type="submit"
                        disabled={!isValid}
                        onClick={handleSubmit}
                        loading={isSubmitting}
                        startIcon={<AddIcon />}
                    >
                        Adicionar
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}

function DialogTelepet({ data, mutate }) {
    const { id: clubId } = useParams();
    const { open, handleClose } = useDialog('#telepet-personalizado');
    const { setErrors, enqueueSnackbar } = useErrors();

    const { values, handleSubmit, handleChange, setValues, isSubmitting } = useFormik({
        initialValues: {
            customTelepetUrl: '',
        },
        onSubmit: async (formValues, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.put(`clubs/${clubId}`, {
                    customTelepetUrl: String(formValues.customTelepetUrl || '').trim() || null,
                });
                enqueueSnackbar('Telepet personalizado salvo.');
                await mutate();
                handleClose();
            } catch (error) {
                setErrors(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    useEffect(() => {
        if (data) {
            setValues({ customTelepetUrl: data.customTelepetUrl || '' }, true);
        }
    }, [data, open, setValues]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Telepet personalizado</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2}>
                    <Alert severity="info">
                        URL do botão Iniciar atendimento do Telepet (site e app). Se ficar em
                        branco, usa o padrão Eurobem.
                    </Alert>
                    <TextField
                        label="URL de atendimento"
                        name="customTelepetUrl"
                        value={values.customTelepetUrl}
                        onChange={handleChange}
                        placeholder="https://..."
                        fullWidth
                        helperText="Deixe em branco para usar o padrão Eurobem."
                    />
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" type="submit" onClick={handleSubmit} loading={isSubmitting}>
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogTelemedicine({ data, mutate }) {
    const { id: clubId } = useParams();
    const { open, handleClose } = useDialog('#telemedicina-personalizada');
    const { setErrors, enqueueSnackbar } = useErrors();

    const { values, handleSubmit, handleChange, setValues, isSubmitting } = useFormik({
        initialValues: {
            customTelemedicineUrl: '',
            clickLifeToken: '',
            clickLifeBusinessId: '',
        },
        onSubmit: async (formValues, { setSubmitting }) => {
            try {
                setSubmitting(true);
                const payload = {
                    customTelemedicineUrl: String(formValues.customTelemedicineUrl || '').trim() || null,
                    clickLifeBusinessId: String(formValues.clickLifeBusinessId || '').trim() || null,
                };
                if (String(formValues.clickLifeToken || '').trim()) {
                    payload.clickLifeToken = String(formValues.clickLifeToken).trim();
                }
                await server.put(`clubs/${clubId}`, payload);
                enqueueSnackbar('Telemedicina personalizada salva.');
                await mutate();
                handleClose();
            } catch (error) {
                setErrors(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    const hasClickLifeToken = Boolean(data?.hasClickLifeToken || data?.hasClickLifeConfig);

    useEffect(() => {
        if (data) {
            setValues({
                customTelemedicineUrl: data.customTelemedicineUrl || '',
                clickLifeToken: '',
                clickLifeBusinessId: data.clickLifeBusinessId || '',
            }, true);
        }
    }, [data, open, setValues]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Telemedicina personalizada</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2}>
                    <Alert severity="info">
                        Token e empresa da Click Life valem para a telemedicina deste clube. Sem token,
                        o atendimento usa a conta Eurobem. A URL abaixo fica só para outro provedor,
                        quando o clube não tem token Click Life.
                    </Alert>
                    <TextField
                        label="URL de atendimento"
                        name="customTelemedicineUrl"
                        value={values.customTelemedicineUrl}
                        onChange={handleChange}
                        placeholder="https://..."
                        fullWidth
                        helperText="Outro provedor. Em branco, o padrão Eurobem só entra se não houver Click Life."
                    />
                    <TextField
                        label="Token Click Life"
                        name="clickLifeToken"
                        value={values.clickLifeToken}
                        onChange={handleChange}
                        type="password"
                        autoComplete="new-password"
                        fullWidth
                        placeholder={hasClickLifeToken ? 'Token já salvo. Preencha só para trocar.' : ''}
                        helperText={
                            hasClickLifeToken
                                ? 'Há um token salvo. Deixe em branco para manter; preencha para substituir.'
                                : 'O token não é exibido depois de salvo.'
                        }
                    />
                    <TextField
                        label="Empresa Click Life"
                        name="clickLifeBusinessId"
                        value={values.clickLifeBusinessId}
                        onChange={handleChange}
                        fullWidth
                        helperText="ID da empresa na Click Life. Usado na inativação do paciente."
                    />
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" type="submit" onClick={handleSubmit} loading={isSubmitting}>
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function DialogTelepsychology({ data, mutate }) {
    const { id: clubId } = useParams();
    const { open, handleClose } = useDialog('#telepsicologia-personalizada');
    const { setErrors, enqueueSnackbar } = useErrors();

    const { values, handleSubmit, handleChange, setValues, isSubmitting } = useFormik({
        initialValues: {
            customTelepsychologyUrl: '',
        },
        onSubmit: async (formValues, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.put(`clubs/${clubId}`, {
                    customTelepsychologyUrl:
                        String(formValues.customTelepsychologyUrl || '').trim() || null,
                });
                enqueueSnackbar('Telepsicologia personalizada salva.');
                await mutate();
                handleClose();
            } catch (error) {
                setErrors(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    useEffect(() => {
        if (data) {
            setValues({ customTelepsychologyUrl: data.customTelepsychologyUrl || '' }, true);
        }
    }, [data, open, setValues]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Telepsicologia personalizada</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2}>
                    <Alert severity="info">
                        URL do botão Iniciar atendimento da Telepsicologia (site e app). Se ficar em
                        branco, usa o padrão Eurobem (WhatsApp).
                    </Alert>
                    <TextField
                        label="URL de atendimento"
                        name="customTelepsychologyUrl"
                        value={values.customTelepsychologyUrl}
                        onChange={handleChange}
                        placeholder="https://..."
                        fullWidth
                        helperText="Deixe em branco para usar o padrão Eurobem."
                    />
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button variant="contained" type="submit" onClick={handleSubmit} loading={isSubmitting}>
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const statuses = {
    pending: { label: 'Pendente', color: 'warning' },
    pending_validation: { label: 'Em validação', color: 'warning' },
    active: { label: 'Ativo', color: 'success' },
    blocked: { label: 'Bloqueado', color: 'error' },
    suspended: { label: 'Suspenso', color: 'error' },
    deleted: { label: 'Removido', color: 'error' },
    error: { label: 'Erro', color: 'error' },
};

function StatusDomain({ domain, clubId, domainStatus }) {
    const { data, error, mutate } = useFetch(`clubs/${clubId}/domains/verify`);

    // // "pending" | "pending_validation" | "active",

    if (error) return '--';
    if (data && Boolean(data?.domainStatus?.errors.length)) {
        return (
            <div>
                <Chip label={statuses['error'].label || 'Processando'} color="error" />
            </div>
        );
    }

    return (
        <Chip
            label={statuses[data?.domainStatus?.result?.status || 'error']?.label || 'Processando'}
            color={statuses[data?.domainStatus?.result?.status || 'error']?.color || 'default'}
        />
    );
}

export default function SettingsClub({ data, mutate }) {
    const { enqueueSnackbar, setErrors } = useErrors();
    const { id: clubId } = useParams();

    const [status, setStatus] = useState(Boolean(data?.status));
    const [viewRescue, setViewRescue] = useState(Boolean(data?.viewRescue));
    const [viewDescontometro, setViewDescontometro] = useState(data?.viewDescontometro !== false);
    const [viewBannerApp, setViewBannerApp] = useState(data?.viewBannerApp !== false);
    const [hasTelemedicineSpecialties, setHasTelemedicineSpecialties] = useState(
        data?.hasTelemedicineSpecialties !== false,
    );
    const [hasExames, setHasExames] = useState(data?.hasExames !== false);
    const [storeUrls, setStoreUrls] = useState({
        androidUrl: data?.androidUrl || '',
        iosUrl: data?.iosUrl || '',
    });
    const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
    const [isUpdatingViewRescue, setIsUpdatingViewRescue] = useState(false);
    const [isUpdatingViewDescontometro, setIsUpdatingViewDescontometro] = useState(false);
    const [isUpdatingViewBannerApp, setIsUpdatingViewBannerApp] = useState(false);
    const [isUpdatingHasTelemedicineSpecialties, setIsUpdatingHasTelemedicineSpecialties] = useState(false);
    const [isUpdatingHasExames, setIsUpdatingHasExames] = useState(false);
    const [isUpdatingStoreUrls, setIsUpdatingStoreUrls] = useState(false);
    const [cutoffDay, setCutoffDay] = useState(data?.cutoffDay || '');
    const [isUpdatingCutoffDay, setIsUpdatingCutoffDay] = useState(false);

    useEffect(() => {
        if (data) {
            setStatus(Boolean(data.status));
            setViewRescue(Boolean(data.viewRescue));
            setViewDescontometro(data.viewDescontometro !== false);
            setViewBannerApp(data.viewBannerApp !== false);
            setHasTelemedicineSpecialties(data.hasTelemedicineSpecialties !== false);
            setHasExames(data.hasExames !== false);
            setStoreUrls({
                androidUrl: data.androidUrl || '',
                iosUrl: data.iosUrl || '',
            });
            setCutoffDay(data.cutoffDay || '');
        }
    }, [data]);

    const handleToggleStatus = async event => {
        const nextStatus = event.target.checked;
        setStatus(nextStatus);

        try {
            setIsUpdatingStatus(true);
            await server.put(`clubs/${clubId}`, { status: nextStatus });
            enqueueSnackbar('Status do clube alterado com sucesso.');
            await mutate();
        } catch (error) {
            setErrors(error);
            setStatus(!nextStatus);
        } finally {
            setIsUpdatingStatus(false);
        }
    };

    const handleToggleViewRescue = async event => {
        const nextValue = event.target.checked;
        setViewRescue(nextValue);

        try {
            setIsUpdatingViewRescue(true);
            await server.put(`clubs/${clubId}`, { viewRescue: nextValue });
            enqueueSnackbar('Permissão de visualização de resgates alterada com sucesso.');
            await mutate();
        } catch (error) {
            setErrors(error);
            setViewRescue(!nextValue);
        } finally {
            setIsUpdatingViewRescue(false);
        }
    };

    const handleToggleViewDescontometro = async event => {
        const nextValue = event.target.checked;
        setViewDescontometro(nextValue);

        try {
            setIsUpdatingViewDescontometro(true);
            await server.put(`clubs/${clubId}`, { viewDescontometro: nextValue });
            enqueueSnackbar('Exibição do descontômetro no app do assinante alterada com sucesso.');
            await mutate();
        } catch (error) {
            setErrors(error);
            setViewDescontometro(!nextValue);
        } finally {
            setIsUpdatingViewDescontometro(false);
        }
    };

    const handleToggleHasTelemedicineSpecialties = async event => {
        const nextValue = event.target.checked;
        setHasTelemedicineSpecialties(nextValue);

        try {
            setIsUpdatingHasTelemedicineSpecialties(true);
            await server.put(`clubs/${clubId}`, { hasTelemedicineSpecialties: nextValue });
            enqueueSnackbar('Exibição do agendamento com especialista alterada com sucesso.');
            await mutate();
        } catch (error) {
            setErrors(error);
            setHasTelemedicineSpecialties(!nextValue);
        } finally {
            setIsUpdatingHasTelemedicineSpecialties(false);
        }
    };

    const handleToggleHasExames = async event => {
        const nextValue = event.target.checked;
        setHasExames(nextValue);

        try {
            setIsUpdatingHasExames(true);
            await server.put(`clubs/${clubId}`, { hasExames: nextValue });
            enqueueSnackbar('Exibição de exames no site e no app alterada com sucesso.');
            await mutate();
        } catch (error) {
            setErrors(error);
            setHasExames(!nextValue);
        } finally {
            setIsUpdatingHasExames(false);
        }
    };

    const handleToggleViewBannerApp = async event => {
        const nextValue = event.target.checked;
        setViewBannerApp(nextValue);

        try {
            setIsUpdatingViewBannerApp(true);
            await server.put(`clubs/${clubId}`, { viewBannerApp: nextValue });
            enqueueSnackbar('Exibição do banner de download do app alterada com sucesso.');
            await mutate();
        } catch (error) {
            setErrors(error);
            setViewBannerApp(!nextValue);
        } finally {
            setIsUpdatingViewBannerApp(false);
        }
    };

    const handleSaveCutoffDay = async () => {
        try {
            setIsUpdatingCutoffDay(true);
            await server.put(`clubs/${clubId}`, { cutoffDay: cutoffDay || null });
            enqueueSnackbar('Dia de corte do clube atualizado.');
            await mutate();
        } catch (error) {
            setErrors(error);
        } finally {
            setIsUpdatingCutoffDay(false);
        }
    };

    const handleSaveStoreUrls = async () => {
        try {
            setIsUpdatingStoreUrls(true);
            await server.put(`clubs/${clubId}`, {
                androidUrl: storeUrls.androidUrl,
                iosUrl: storeUrls.iosUrl,
            });
            enqueueSnackbar('Links de aplicativo alterados com sucesso.');
            await mutate();
        } catch (error) {
            setErrors(error);
        } finally {
            setIsUpdatingStoreUrls(false);
        }
    };

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <Card sx={{ minWidth: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <CardHeader title="Corte de benefícios" />
                        <Divider />
                        <CardContent sx={{ flex: 1 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Se preenchido, todos os benefícios ativos do clube entram nesse dia. Vazio usa o corte de cada assinante.
                            </Typography>
                            <TextField
                                select
                                fullWidth
                                label="Dia de corte global"
                                value={cutoffDay}
                                onChange={e => setCutoffDay(e.target.value)}
                            >
                                <MenuItem value="">Sem corte global</MenuItem>
                                <MenuItem value="10">Dia 10</MenuItem>
                                <MenuItem value="20">Dia 20</MenuItem>
                                <MenuItem value="last">Último dia do mês</MenuItem>
                            </TextField>
                        </CardContent>
                        <CardActions sx={{ justifyContent: 'flex-end' }}>
                            <Button variant="contained" onClick={handleSaveCutoffDay} disabled={isUpdatingCutoffDay}>
                                {isUpdatingCutoffDay ? 'Salvando…' : 'Salvar'}
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card sx={{ minWidth: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <CardHeader title="Segmentação" />
                        <Divider />
                        <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <Stack direction="row" justifyContent="space-between">
                                <Stack rowGap={1} direction="row" gap={8}>
                                    <Box>
                                        <Typography variant="title-sm">Categorias Ativas</Typography>
                                        <Typography variant="title-md">{data?.ClubCategory?.length || '--'}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="title-sm">Categorias sem Interesse</Typography>
                                        <Typography variant="title-md">{data?.excludeCategory?.length || '--'}</Typography>
                                    </Box>
                                </Stack>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <Button variant="outlined" component={Link} to="#segmentacao">
                                Alterar
                            </Button>
                            <Button variant="outlined" color="secondary" component={Link} to="#excluidas">
                                Sem interesse
                            </Button>
                        </CardActions>
                    </Card>
                    <DialogSegments data={data} mutate={mutate} />
                    <DialogSegmentsExclude data={data} mutate={mutate} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card sx={{ minWidth: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <CardHeader title="Aplicativo" />
                        <Divider />
                        <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <Stack rowGap={1}>
                                <Typography variant="title-sm">{data.packageName || '--'}</Typography>
                                <Typography variant="title-sm">{data.appIntent || '--'}</Typography>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <Button component={Link} to="#app" variant="outlined">
                                Alterar
                            </Button>
                        </CardActions>
                    </Card>
                    <DialogApp data={data} mutate={mutate} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card sx={{ minWidth: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <CardHeader title="Telemedicina personalizada" />
                        <Divider />
                        <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <Stack rowGap={1}>
                                <Typography variant="title-sm">URL de atendimento</Typography>
                                <Typography variant="title-md" sx={{ wordBreak: 'break-all' }}>
                                    {data?.customTelemedicineUrl || '--'}
                                </Typography>
                                <Typography variant="title-sm">Token Click Life</Typography>
                                <Typography variant="title-md">
                                    {data?.hasClickLifeToken || data?.hasClickLifeConfig ? 'Salvo' : 'Não configurado'}
                                </Typography>
                                <Typography variant="title-sm">Empresa Click Life</Typography>
                                <Typography variant="title-md" sx={{ wordBreak: 'break-all' }}>
                                    {data?.clickLifeBusinessId || '--'}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    O token não é exibido. A URL só entra se o clube não tiver Click Life.
                                </Typography>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <Button component={Link} to="#telemedicina-personalizada" variant="outlined">
                                {data?.customTelemedicineUrl ? 'Alterar' : 'Configurar'}
                            </Button>
                        </CardActions>
                    </Card>
                    <DialogTelemedicine data={data} mutate={mutate} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card sx={{ minWidth: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <CardHeader title="Telepet personalizado" />
                        <Divider />
                        <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <Stack rowGap={1}>
                                <Typography variant="title-sm">URL de atendimento</Typography>
                                <Typography variant="title-md" sx={{ wordBreak: 'break-all' }}>
                                    {data?.customTelepetUrl || '--'}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Coluna do clube ou padrão Eurobem (abre fora do clube).
                                </Typography>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <Button component={Link} to="#telepet-personalizado" variant="outlined">
                                {data?.customTelepetUrl ? 'Alterar' : 'Configurar'}
                            </Button>
                        </CardActions>
                    </Card>
                    <DialogTelepet data={data} mutate={mutate} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card sx={{ minWidth: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <CardHeader title="Telepsicologia personalizada" />
                        <Divider />
                        <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <Stack rowGap={1}>
                                <Typography variant="title-sm">URL de atendimento</Typography>
                                <Typography variant="title-md" sx={{ wordBreak: 'break-all' }}>
                                    {data?.customTelepsychologyUrl || '--'}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Coluna do clube ou padrão Eurobem/WhatsApp.
                                </Typography>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <Button component={Link} to="#telepsicologia-personalizada" variant="outlined">
                                {data?.customTelepsychologyUrl ? 'Alterar' : 'Configurar'}
                            </Button>
                        </CardActions>
                    </Card>
                    <DialogTelepsychology data={data} mutate={mutate} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
                                <Business color="primary" />
                                <Typography variant="h6">Status do Clube</Typography>
                            </Stack>

                            <Stack spacing={2}>
                                <Box>
                                    <Typography sx={{ mb: 1 }} variant="body2" color="text.secondary">
                                        Status
                                    </Typography>
                                    <Chip
                                        label={status ? 'Ativo' : 'Inativo'}
                                        color={status ? 'success' : 'default'}
                                        size="small"
                                    />
                                </Box>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={status}
                                        onChange={handleToggleStatus}
                                        disabled={isUpdatingStatus}
                                        color="primary"
                                    />
                                }
                                label={status ? 'Ativo' : 'Inativo'}
                            />
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
                                {viewRescue ? (
                                    <VisibilityIcon color="primary" />
                                ) : (
                                    <VisibilityOffIcon color="primary" />
                                )}

                                <Typography variant="h6">{data?.viewRescue ? 'Visualizar resgates': 'Ocultar resgates'}</Typography>
                            </Stack>

                            <Stack spacing={2}>
                                <Box>
                                    <Typography sx={{ mb: 1 }} variant="body2" color="text.secondary">
                                       {data?.viewRescue ? 'Permite o gestor do clube visualizar os seus resgates.' : 'O gestor do clube não pode visualizar os resgates.'}
                                    </Typography>
                                    <Chip
                                        label={viewRescue ? 'Ativo' : 'Inativo'}
                                        color={viewRescue ? 'success' : 'default'}
                                        size="small"
                                    />
                                </Box>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={viewRescue}
                                        onChange={handleToggleViewRescue}
                                        disabled={isUpdatingViewRescue}
                                        color="primary"
                                    />
                                }
                                label={viewRescue ? 'Ativo' : 'Inativo'}
                            />
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
                                {viewDescontometro ? (
                                    <VisibilityIcon color="primary" />
                                ) : (
                                    <VisibilityOffIcon color="primary" />
                                )}

                                <Typography variant="h6">
                                    {data?.viewDescontometro !== false ? 'Exibir descontômetro' : 'Ocultar descontômetro'}
                                </Typography>
                            </Stack>

                            <Stack spacing={2}>
                                <Box>
                                    <Typography sx={{ mb: 1 }} variant="body2" color="text.secondary">
                                        {data?.viewDescontometro !== false
                                            ? 'Permite que o assinante veja o descontômetro no painel do assinante.'
                                            : 'O descontômetro fica oculto no painel do assinante.'}
                                    </Typography>
                                    <Chip
                                        label={viewDescontometro ? 'Ativo' : 'Inativo'}
                                        color={viewDescontometro ? 'success' : 'default'}
                                        size="small"
                                    />
                                </Box>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={viewDescontometro}
                                        onChange={handleToggleViewDescontometro}
                                        disabled={isUpdatingViewDescontometro}
                                        color="primary"
                                    />
                                }
                                label={viewDescontometro ? 'Ativo' : 'Inativo'}
                            />
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
                                <GetApp color="primary" />
                                <Typography variant="h6">
                                    {viewBannerApp ? 'Exibir banner do app' : 'Ocultar banner do app'}
                                </Typography>
                            </Stack>

                            <Stack spacing={2}>
                                <Box>
                                    <Typography sx={{ mb: 1 }} variant="body2" color="text.secondary">
                                        {viewBannerApp
                                            ? 'Mostra o banner de download do aplicativo no site do clube.'
                                            : 'O banner de download do aplicativo fica oculto no site do clube.'}
                                    </Typography>
                                    <Chip
                                        label={viewBannerApp ? 'Ativo' : 'Inativo'}
                                        color={viewBannerApp ? 'success' : 'default'}
                                        size="small"
                                    />
                                </Box>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={viewBannerApp}
                                        onChange={handleToggleViewBannerApp}
                                        disabled={isUpdatingViewBannerApp}
                                        color="primary"
                                    />
                                }
                                label={viewBannerApp ? 'Ativo' : 'Inativo'}
                            />
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
                                <MedicalServicesOutlined color="primary" />
                                <Typography variant="h6">
                                    {hasTelemedicineSpecialties
                                        ? 'Agendamento com especialista'
                                        : 'Ocultar agendamento com especialista'}
                                </Typography>
                            </Stack>

                            <Stack spacing={2}>
                                <Box>
                                    <Typography sx={{ mb: 1 }} variant="body2" color="text.secondary">
                                        {hasTelemedicineSpecialties
                                            ? 'Mostra o bloco de agendamento com especialista na telemedicina do clube.'
                                            : 'O bloco de agendamento com especialista fica oculto no site do clube.'}
                                    </Typography>
                                    <Chip
                                        label={hasTelemedicineSpecialties ? 'Ativo' : 'Inativo'}
                                        color={hasTelemedicineSpecialties ? 'success' : 'default'}
                                        size="small"
                                    />
                                </Box>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={hasTelemedicineSpecialties}
                                        onChange={handleToggleHasTelemedicineSpecialties}
                                        disabled={isUpdatingHasTelemedicineSpecialties}
                                        color="primary"
                                    />
                                }
                                label={hasTelemedicineSpecialties ? 'Ativo' : 'Inativo'}
                            />
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
                                <ScienceOutlined color="primary" />
                                <Typography variant="h6">
                                    {hasExames ? 'Exibir exames' : 'Ocultar exames'}
                                </Typography>
                            </Stack>

                            <Stack spacing={2}>
                                <Box>
                                    <Typography sx={{ mb: 1 }} variant="body2" color="text.secondary">
                                        {hasExames
                                            ? 'Mostra exames (laboratórios) na landing, planos, hub e app.'
                                            : 'Exames ficam ocultos no site e no app do clube.'}
                                    </Typography>
                                    <Chip
                                        label={hasExames ? 'Ativo' : 'Inativo'}
                                        color={hasExames ? 'success' : 'default'}
                                        size="small"
                                    />
                                </Box>
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={hasExames}
                                        onChange={handleToggleHasExames}
                                        disabled={isUpdatingHasExames}
                                        color="primary"
                                    />
                                }
                                label={hasExames ? 'Ativo' : 'Inativo'}
                            />
                        </CardActions>
                    </Card>
                </Grid>

                {/* <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
                                <Business color="primary" />
                                <Typography variant="h6">Links do aplicativo</Typography>
                            </Stack>

                            <Stack spacing={2}>
                                <TextField
                                    label="Android URL"
                                    placeholder="https://play.google.com/..."
                                    value={storeUrls.androidUrl}
                                    onChange={event => setStoreUrls(prev => ({ ...prev, androidUrl: event.target.value }))}
                                    fullWidth
                                />
                                <TextField
                                    label="iOS URL"
                                    placeholder="https://apps.apple.com/..."
                                    value={storeUrls.iosUrl}
                                    onChange={event => setStoreUrls(prev => ({ ...prev, iosUrl: event.target.value }))}
                                    fullWidth
                                />
                            </Stack>
                        </CardContent>
                        <Divider />
                        <CardActions>
                            <Button variant="outlined" onClick={handleSaveStoreUrls} disabled={isUpdatingStoreUrls}>
                                {data?.androidUrl || data?.iosUrl ? 'Alterar' : 'Adicionar'}
                            </Button>
                        </CardActions>
                    </Card>
                </Grid> */}

            </Grid>
        </Box>
    );
};
